// material-ui
import {} from '@mui/material'

// assets

import CustomerAdministratorHomePageManagerComponent from 'components/CustomerAdministratorHomePageManagerComponent'

// ================================|| UI LIST - SIMPLE LIST ||================================ //

export default function SimpleList() {
  // Generate Grid

  function main(): any {
    return <CustomerAdministratorHomePageManagerComponent />
  }

  let output_main = main()

  return output_main
}
